module.exports = __webpack_public_path__ + "img/testimonials1.cd8abece.jpg";